<template lang="pug">
  p.ItemIndex {{ idx }}
</template>

<script>

export default {
  props: {
    index: {
      default: 0,
      type: Number
    },
    size: {
      default: 2,
      type: Number
    }
  },
  computed: {
    idx () {
      return this.pad()
    }
  },
  methods: {
    pad () {
      let s = String(this.index + 1)
      while (s.length < (this.size || 2)) { s = '0' + s }
      return s
    }
  }
}

</script>

<style lang="stylus" scope>

.ItemIndex

  font-family: 'Sectra Display'
  line-height 0.75em
  color currentColor
  position absolute
  font-size 20px
  top 5px
  right 10px
  text-align: right;
  
  @media $mq_m
    top 10px
    right 20px
    font-size 25px

  @media $mq_l
    top 25px
    right 30px
    font-size 30px
    

</style>
